module.exports = __webpack_public_path__ + "static/media/Photo4.629a4fd1.jpg";